// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"c31db0d1","130":"75de27d2","305":"144f3d6b","725":"fd5c6ffe","848":"76b71ddc","912":"39eeca4f","950":"252dbd7a"}[chunkId] + ".chunk.js";
};